export default "__VITE_ASSET__NMfQytUZ__"